import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { AdminUser, AuthState } from '@/types/auth.types';
import { auth } from '@/utils/auth';
import logger from '@/utils/logger';

const initialState: AuthState = {
  user: auth.getUserInfo(),
  token: auth.getToken(),
  loading: false,
  error: null,
  isAuthenticated: auth.isAuthenticated(),
};

logger.log('Auth Initial State:', initialState);

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginRequest(state, _action: PayloadAction<{ email: string; password: string; remember: boolean }>) {
      state.loading = true;
      state.error = null;
    },
    loginSuccess(state, action: PayloadAction<{ user: AdminUser; token: string }>) {
      logger.log('loginSuccess called with:', action.payload);
      state.loading = false;
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.isAuthenticated = true;
      state.error = null;
      logger.log('Auth state after loginSuccess:', { ...state });
    },
    loginFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    googleLoginRequest(state, _action: PayloadAction<{ credential: string; remember: boolean }>) {
      state.loading = true;
      state.error = null;
    },
    logoutRequest(state) {
      state.loading = true;
    },
    logoutSuccess(state) {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      state.loading = false;
      state.error = null;
    },
    setUser(state, action: PayloadAction<AdminUser>) {
      state.user = action.payload;
    },
  },
});

export const {
  loginRequest,
  loginSuccess,
  loginFailure,
  googleLoginRequest,
  logoutRequest,
  logoutSuccess,
  setUser,
} = authSlice.actions;

export default authSlice.reducer;
